
export default {
  en: {

  }
};
